import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class HeaderService {
    constructor(private httpClient: HttpClient) { }
    isMobile = false;
    subjectMobile: BehaviorSubject<any> = new BehaviorSubject<any>(this.isMobile);
    subjectSmallScreen: BehaviorSubject<any> = new BehaviorSubject<any>(this.isMobile);
    isSmallScreen = false;
    setIsSmallScreen(size: number) {
        if(size < 992) {
            this.subjectSmallScreen.next(true);
            this.isSmallScreen = true;
        } else {
            this.subjectSmallScreen.next(false);
            this.isSmallScreen = false;
        }
    }
    readIsSmallScreen() {
        return this.isSmallScreen;
    }
    setIsMobile(size: number) {

        if(size < 481) {
            this.subjectMobile.next(true);
            this.isMobile = true;

        } else {
            this.subjectMobile.next(false);
            this.isMobile = false;
        }
        }
    readIsMobile() {
        return this.isMobile;
    }
    searchUser(query: string) {
        return this.httpClient.get<Array<any>>(`${environment.serverPath}/profile/search?query=${query}&items=10`);
    }
}